(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabScheduleDeleteController',TabScheduleDeleteController);

    TabScheduleDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabSchedule'];

    function TabScheduleDeleteController($uibModalInstance, entity, TabSchedule) {
        var vm = this;
        vm.tabSchedule = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabSchedule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
